import React, {ReactElement} from "react";
import {Blockquote} from "@mantine/core";

export type StepperContentProps = {
    title?: string | boolean,
    description: string | boolean
    children: ReactElement
}

export function StepperContentVertical(props: StepperContentProps) {
    return (
        <div className={"stepper-content-vertical"}>
            {props.title && (<div>
                <div className={""}>
                    <h2 className={"stepper-content-vertical-title"}>{props.title}</h2>
                </div>
                <div>
                    <Blockquote cite="- Sellina ">
                        {props.description}
                    </Blockquote>
                </div>
            </div>)}
            <div className={"stepper-right  full-width-height"}>
                {props.children}
            </div>

        </div>

    );
}
